<template>
  <div v-role="'func'">
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-card width="1200" class="mx-auto">
        <!-- Loading overlay -->
        <v-overlay :value="overlay">
          <v-progress-circular indeterminate size="70"></v-progress-circular>
        </v-overlay>

        <!-- Card header -->
        <v-card-title class="primary white--text">
          <v-icon left>account_balance</v-icon>
          <span class="headline">Novo Banco</span>
          <v-spacer></v-spacer>
          <v-btn to="visualizar-contas" color="white" outlined>
            <v-icon left>list</v-icon>
            Consultar Contas
          </v-btn>
        </v-card-title>

        <!-- Tabs navigation -->
        <v-tabs v-model="tab" background-color="primary" dark>
          <v-tab v-for="item in tabs" :key="item.tab">
            <v-icon left>{{ item.icon }}</v-icon>
            {{ item.tab }}
          </v-tab>
        </v-tabs>

        <!-- Alert message -->
        <v-alert v-model="alert" dismissible :type="alertType" border="left" :icon="iconAlert" colored-border>
          {{ msgAlert }}
        </v-alert>

        <!-- Tab content -->
        <v-tabs-items v-model="tab">
          <!-- General Tab -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-text-field v-model="editedItem.nome" :rules="ruleRequiredSemNumero" label="Nome do Banco*"
                        outlined required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="2">
                      <v-text-field v-model="editedItem.sigla" :rules="ruleSigla" label="Sigla*" outlined
                        required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="editedItem.endereco" label="Endereço" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="editedItem.telefone1" label="Telefone" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="editedItem.email" label="Email" outlined></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="editedItem.observacao" label="Observação" outlined></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" :disabled="!valid" @click="saveBanco" :loading="overlay">
                  <v-icon left>save</v-icon>
                  Submeter
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>

          <!-- Bank Accounts Tab -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <h3 class="mb-4">
                  <v-icon left>credit_card</v-icon>
                  Associação de contas Bancária
                </h3>
                <v-form ref="form2" v-model="valid2" lazy-validation>
                  <v-row>
                    <v-col cols="12" md="8">
                      <v-combobox v-model="bancoSelected" :items="bancos" :rules="ruleJustRequired" item-text="nome"
                        item-value="nome" label="Selecione o Banco*" outlined required clearable>
                        <template v-slot:item="{ item }">
                          <v-list-item-content>
                            <v-list-item-title>{{ item.nome }}</v-list-item-title>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn icon @click.stop="confirmDeleteBank(item)">
                              <v-icon small color="error">delete</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </template>
                      </v-combobox>
                    </v-col>
                  </v-row>

                  <v-data-table :headers="accountHeaders" :items="contas" hide-default-footer class="elevation-1">
                    <template v-slot:item.conta="{ item }">
                      <v-text-field v-model="item.conta" :rules="ruleRequired" label="Nº Conta*" outlined
                        dense></v-text-field>
                    </template>
                    <template v-slot:item.iban="{ item }">
                      <v-text-field v-mask="'AO-####-####-####-####-####-#'" v-model="item.iban"
                        :rules="ruleRequiredIban" label="IBAN*" outlined dense></v-text-field>
                    </template>
                    <template v-slot:item.descricao="{ item }">
                      <v-text-field v-model="item.descricao" label="Descrição" outlined dense></v-text-field>
                    </template>
                    <template v-slot:item.moeda="{ item }">
                      <v-combobox v-model="contas[contas.indexOf(item)].moeda" :items="moedas"
                        :search-input.sync="search" hide-selected filled outlined
                        item-text="descricao" item-value="descricao" label="Selecione" small-chips
                        :rules="ruleJustRequired" @click="ListarMoedas()">
                      </v-combobox>
                    </template>
                    <template v-slot:item.delete="{ item }">
                      <v-btn icon color="error" @click="removeAccount(contas.indexOf(item))">
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" fab small @click="addAccount" :disabled="!valid2">
                  <v-icon>add</v-icon>
                </v-btn>
                <v-btn color="success" :disabled="!valid2" @click="saveAccount" :loading="overlay">
                  <v-icon left>save</v-icon>
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import axios from '../../plugins/axios';
import { mask } from 'vue-the-mask';
import utilitarios from '../../plugins/utilitarios';
import Swal from 'sweetalert2';
const ls = require('local-storage');

export default {
  directives: { mask },
  data: () => ({
    // UI State
    overlay: false,
    alert: false,
    alertType: 'success',
    iconAlert: '',
    msgAlert: '',
    tab: 0,
    valid: false,
    valid2: false,

    // Form Data
    editedItem: {
      nome: '',
      endereco: '',
      telefone1: '',
      telefone2: '',
      email: '',
      observacao: '',
      sigla: ''
    },
    bancoSelected: null,
    contas: [],

    // Data Lists
    bancos: [],
    moedas: [],
    contasCadastradas: [],

    // UI Configuration
    tabs: [
      { tab: 'Geral', icon: 'settings', content: 'Tab 1 Content' },
      { tab: 'Conta Bancária', icon: 'account_balance_wallet', content: 'Tab 2 Content' }
    ],
    accountHeaders: [
      { text: 'Nº de Conta', value: 'conta', width: '25%' },
      { text: 'IBAN', value: 'iban', width: '25%' },
      { text: 'Descrição', value: 'descricao', width: '25%' },
      { text: 'Moeda', value: 'moeda', width: '20%' },
      { text: 'Ações', value: 'delete', sortable: false, width: '5%' }
    ],

    // Validation Rules
    ruleJustRequired: [value => !!value || 'Campo obrigatório'],
    ruleSigla: [
      value => !!value || 'Campo obrigatório',
      value => (value || '').length >= 2 || 'Mínimo 2 caracteres'
    ],
    ruleRequiredIban: [
      value => !!value || 'Campo obrigatório',
      value => (value || '').length >= 2 || 'Mínimo 2 caracteres'
    ],
    ruleRequired: [
      value => !!value || 'Campo obrigatório',
      value => (value || '').length >= 2 || 'Mínimo 2 caracteres'
    ],
    ruleRequiredSemNumero: [
      value => !!value || 'Campo obrigatório',
      value => (value || '').length > 3 || 'Mínimo 3 caracteres',
      value => !/[0-9{};=+~_!@#$%^&*()/,.?":|<>]/.test(value) || 'Caracteres inválidos'
    ],
    ruleEmailRequired: [
      value => !value || value.length <= 50 || 'Máximo 50 caracteres',
      value => {
        if (!value) return true;
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || 'E-mail inválido';
      }
    ]
  }),

  computed: {
    loggedUserName() {
      return ls.get('nomeUsuario');
    },
    instituicao() {
      return ls.get('i_id');
    }
  },

  created() {
    this.initializeData();
  },

  methods: {
    async initializeData() {
      try {
        this.overlay = true;
        await Promise.all([
          this.loadBanks(),
          this.loadCurrencies(),
          this.loadBankAccounts()
        ]);
      } catch (error) {
        this.showError('Erro ao carregar dados iniciais');
      } finally {
        this.overlay = false;
      }
    },

    async loadBanks() {
      this.bancos = await axios.get('/bancosFindAll').then(res => res.data);
    },

    async loadCurrencies() {
      this.moedas = await axios.get('/moedaFindAll').then(res => res.data);
    },

    async loadBankAccounts() {
      this.contasCadastradas = await axios.get('/conta-bancariaFindAll-escola').then(res => res.data);
    },

    addAccount() {
      if (this.$refs.form2.validate()) {
        this.contas.push({
          conta: '',
          iban: 'AO',
          descricao: '',
          moeda: null
        });
      }
    },

    removeAccount(index) {
      this.contas.splice(index, 1);
    },

    async saveBanco() {
      if (!this.$refs.form.validate()) return;

      const bankExists = this.bancos.some(b =>
        b.nome.toLowerCase() === this.editedItem.nome.toLowerCase()
      );

      if (bankExists) {
        this.showWarning('Banco já cadastrado');
        return;
      }

      try {
        this.overlay = true;
        const params = {
          pkBanco: 0,
          nome: this.editedItem.nome,
          endereco: this.editedItem.endereco,
          telefone: this.editedItem.telefone1,
          email: this.editedItem.email,
          obs: this.editedItem.observacao,
          sigla: this.editedItem.sigla
        };

        const result = await axios.post('/BancoFatInsertOrUpdate', params);

        if (result.data.affectedRows >= 1) {
          this.showSuccess('Banco inserido com sucesso');
          this.resetForm();
          await this.loadBanks();
        }
      } catch (error) {
        this.showError('Erro ao salvar banco');
      } finally {
        this.overlay = false;
      }
    },

    async saveAccount() {
      if (!this.$refs.form2.validate()) return;

      const accountExists = this.contasCadastradas.some(c =>
        c.numeroConta.toLowerCase() === this.contas[0].conta.toLowerCase() &&
        c.instituicao === this.instituicao &&
        c.iban.toLowerCase() === this.contas[0].iban.toLowerCase() &&
        c.descricao.toLowerCase() === this.contas[0].descricao.toLowerCase()
      );

      if (accountExists) {
        this.showWarning('Conta Bancária já cadastrada');
        return;
      }

      try {
        this.overlay = true;
        const params = {
          banco: this.bancoSelected,
          contas: this.contas,
          autor: this.loggedUserName
        };

        const result = await axios.post('/ContaFatInsertOrUpdate', params);

        if (result.data.affectedRows >= 1) {
          this.showSuccess('Conta associada ao Banco com sucesso');
          this.resetAccountForm();
          await this.loadBankAccounts();
        }
      } catch (error) {
        this.showError('Erro ao salvar conta bancária');
      } finally {
        this.overlay = false;
      }
    },

    async confirmDeleteBank(item) {
      const result = await Swal.fire({
        title: 'Eliminar Banco?',
        text: "Esta ação não pode ser desfeita!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'Eliminar',
        cancelButtonText: 'Cancelar'
      });

      if (!result.isConfirmed) return;

      try {
        this.overlay = true;
        const hasAccounts = await axios.post('bancoAssociadoanyAccout', item)
          .then(res => res.data.length > 0);

        if (hasAccounts) {
          this.showWarning('Banco associado a uma conta bancária, impossível eliminar');
          return;
        }

        const result = await axios.post('eliminarBanco', item);

        if (result.data.affectedRows >= 1) {
          this.showSuccess('Banco eliminado com sucesso');
          await this.loadBanks();
          this.bancoSelected = null;
        }
      } catch (error) {
        this.showError('Erro ao eliminar banco');
      } finally {
        this.overlay = false;
      }
    },

    resetForm() {
      this.$refs.form.reset();
      this.tab = 0;
    },

    resetAccountForm() {
      this.contas = [];
      this.bancoSelected = null;
      this.$refs.form2.resetValidation();
    },

    showSuccess(message) {
      Swal.fire('Informação', message, 'success')
    },

    showWarning(message) {
      Swal.fire('Informação', message, 'warning')
    },

    showError(message) {
      Swal.fire('Informação', message, 'error')
    }
  }
};
</script>

<style scoped>
.primary {
  background-color: #006699 !important;
}

.v-card {
  border-radius: 8px;
  overflow: hidden;
  margin-top: 20px;
}

.v-data-table {
  margin-top: 16px;
}

.headline {
  font-size: 1.5rem;
  font-weight: 500;
}
</style>